var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16.2812C1 16.074 1.08231 15.8753 1.22882 15.7288C1.37534 15.5823 1.57405 15.5 1.78125 15.5H17.4062C17.6135 15.5 17.8122 15.5823 17.9587 15.7288C18.1052 15.8753 18.1875 16.074 18.1875 16.2812C18.1875 16.4885 18.1052 16.6872 17.9587 16.8337C17.8122 16.9802 17.6135 17.0625 17.4062 17.0625H1.78125C1.57405 17.0625 1.37534 16.9802 1.22882 16.8337C1.08231 16.6872 1 16.4885 1 16.2812ZM1 10.0312C1 9.82405 1.08231 9.62534 1.22882 9.47882C1.37534 9.33231 1.57405 9.25 1.78125 9.25H17.4062C17.6135 9.25 17.8122 9.33231 17.9587 9.47882C18.1052 9.62534 18.1875 9.82405 18.1875 10.0312C18.1875 10.2385 18.1052 10.4372 17.9587 10.5837C17.8122 10.7302 17.6135 10.8125 17.4062 10.8125H1.78125C1.57405 10.8125 1.37534 10.7302 1.22882 10.5837C1.08231 10.4372 1 10.2385 1 10.0312ZM1 3.78125C1 3.57405 1.08231 3.37534 1.22882 3.22882C1.37534 3.08231 1.57405 3 1.78125 3H17.4062C17.6135 3 17.8122 3.08231 17.9587 3.22882C18.1052 3.37534 18.1875 3.57405 18.1875 3.78125C18.1875 3.98845 18.1052 4.18716 17.9587 4.33368C17.8122 4.48019 17.6135 4.5625 17.4062 4.5625H1.78125C1.57405 4.5625 1.37534 4.48019 1.22882 4.33368C1.08231 4.18716 1 3.98845 1 3.78125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.e8ffbca09ddfa0947ef1f2ce32d60951.svg";
export { ForwardRef as ReactComponent };